export var Language;
(function (Language) {
    Language["EN"] = "en";
    Language["NL"] = "nl";
    Language["DE"] = "de";
})(Language || (Language = {}));
export const flagMap = {
    [Language.EN]: "/assets/images/us-flag.svg",
    [Language.NL]: "/assets/images/nl-flag.svg",
    [Language.DE]: "/assets/images/de-flag.svg",
};
export const getLanguageDisplay = (lang, isLargeScreen) => {
    const fullLabels = {
        [Language.EN]: "English",
        [Language.NL]: "Nederlands",
        [Language.DE]: "Deutsch",
    };
    const shortLabels = {
        [Language.EN]: "EN",
        [Language.NL]: "NL",
        [Language.DE]: "DE",
    };
    return isLargeScreen ? fullLabels[lang] : shortLabels[lang];
};
